<template>
  <v-container class="pa-0">
    <Subheader dense title="Tenants" no-search>
      <v-btn small color="add" @click="clickAddTenant()">
        <v-icon class="mr-1">add</v-icon>
        {{ $t('Button.Add') }}
      </v-btn>
    </Subheader>

    <v-card>
      <v-card-text>
        <v-data-table :headers="headers" :items="tenantList" :pagination.sync="pagination">
          <template slot="items" slot-scope="props">
            <td class="text-xs-left">{{ props.item.RoleName }}</td>
            <td class="text-xs-right">
              <v-btn color="delete" small dark @click="clickDeleteTenant(props.item)">
                <v-icon class="mr-1">delete_forever</v-icon>
                {{ $t('Button.Remove') }}
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialog" persistent max-width="800px">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>{{ $t('GuidelinesDetailTenant.addTenantTitleMsg') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-layout row wrap pl-5 pr-5>
            <v-flex xs12>
              <v-autocomplete label="Tenant List" v-model="newTenantGuideline" :items="remainTenantList" item-text="RoleName" return-object></v-autocomplete>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" @click="addGuidelineTenant()">
            <v-icon class="mr-1">add</v-icon>
            {{ $t('Button.Add') }}
          </v-btn>
          <v-btn outline color="secondary" @click="closeDialog()">{{ $t('Button.Cancel') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="comfirmDialog" max-width="500">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>
            {{ $t('GuidelinesDetailTenant.confirmTitleMsg', { msg1: deleteTenant.RoleName, msg2: name }) }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="comfirmDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>{{ $t('GuidelinesDetailTenant.confirmTextMsg') }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click.native="deleteGuidelineTenant()">
            <v-icon class="mr-1">delete_forever</v-icon>
            {{ $t('Button.Remove') }}
          </v-btn>
          <v-btn depressed @click.native="comfirmDialog = false">{{ $t('Button.Cancel') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card>
      <v-snackbar style="text-align:center" :color="snackColor" :timeout="null" top v-model="snackbar" auto-height>
        {{ snackMessage }}
        <v-btn dark flat @click.native="snackbar = false">{{ $t('Button.Close') }}</v-btn>
      </v-snackbar>
    </v-card>
  </v-container>
</template>

<script>
  import Subheader from '@/components/generic/Subheader'

  import {
    createNamespacedHelpers,
  } from 'vuex'
  const admin = createNamespacedHelpers('admin')
  const authenticate = createNamespacedHelpers('authenticate')
  const stations = createNamespacedHelpers('stations')
  const guidelines = createNamespacedHelpers('guidelines')
  export default {
    components: {
      Subheader,
    },
    props: {
      name: {
        type: String,
        default: '',
      },
      currentGuideline: {
        type: Object,
        default: () => {},
      },
      isAddpageForm: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        headers: [{
          text: 'Tenant',
          value: 'RoleName',
          align: 'left',
        },
        {
          text: 'Action',
          value: '',
          align: 'right',
        },
        ],
        pagination: {
          sortBy: 'RoleName',
          rowsPerPage: 5,
        },
        dialog: false,
        comfirmDialog: false,
        tenantList: [],
        remainTenantList: [],
        newTenantGuideline: {},
        newIsEditable: false,
        deleteTenant: {},
        snackbar: false,
        snackColor: '',
        snackMessage: '',
      }
    },
    mounted() {
      if (!this.roleList || !this.roleList.length) {
        this.getRoleList()
      }
      this.setTenantList()
    },
    computed: {
      ...admin.mapGetters(['roleList']),
      ...authenticate.mapGetters(['isSystemAdmin', 'currentUserGroup']),
      ...stations.mapGetters(['mediaTypeList']),
      ...guidelines.mapGetters(['Guidelines']),
    },
    watch: {
      currentGuideline() {
        this.setTenantList()
      },
      roleList() {
        this.setTenantList()
      },
    },
    methods: {
      ...admin.mapActions(['getRoleList']),
      ...guidelines.mapActions(['postAddGuidelineTenant', 'postUpdateGuidelineTenant', 'postUnlinkGuidelineTenant']),
      startSnack(snackColor, snackMessage) {
        this.snackMessage = snackMessage
        this.snackColor = snackColor
        this.snackbar = true
      },
      setTenantList() {
        let list = []
        let remainList = []
        let dc = JSON.parse(JSON.stringify(this.currentGuideline.TenantGuidelines))
        this.roleList.forEach(e => {
          let tenant = dc.find(x => x.TenantId == e.Id)
          if (tenant) {
            list.push({
              Id: e.Id,
              RoleName: e.RoleName,
              IsEditable: tenant.IsEditable == '1' ? true : false,
            })
          } else {
            remainList.push({
              Id: e.Id,
              RoleName: e.RoleName,
            })
          }
        })
        this.tenantList = list
        this.remainTenantList = remainList
      },
      clickAddTenant() {
        if (this.remainTenantList.length == 0) {
          this.startSnack('warning', this.$t('GuidelinesDetailTenant.addTenantFailMsg'))
        } else {
          this.dialog = true
        }
      },
      clickDeleteTenant(tenant) {
        this.comfirmDialog = true
        this.deleteTenant = tenant
      },
      closeDialog() {
        this.dialog = false
        this.newTenantGuideline = {}
      },
      addGuidelineTenant() {
        if (!this.newTenantGuideline) {
          this.startSnack('info', this.$t('GuidelinesDetailTenant.addGuidelineTenantFailMsg'))
        }
        let existTenants = this.tenantList.map(x => {
          return {
            IsEditable: x.IsEditable,
            TenantId: x.Id,
          } 
        })
        let options = {
          data: {
            GuidelineId: this.currentGuideline.Id,
            Tenants: [...existTenants, {
              IsEditable: this.newIsEditable,
              TenantId: this.newTenantGuideline.Id,
            }],
          },
          successCb: () => {
            this.startSnack('success', this.$t('GuidelinesDetailTenant.addGuidelineTenantSuccessMsg'))
            this.closeDialog()
          },
          failedCb: (err) => {
            this.startSnack('error', err)
          },
        }
        this.postAddGuidelineTenant(options)
      },
      updateGuidelineTenant() {
        var tenants = []
        this.tenantList.forEach(e => {
          tenants.push({
            TenantId: e.Id,
            IsEditable: e.IsEditable,
          })
        })
        let options = {
          data: {
            GuidelineId: this.currentGuideline.Id,
            Tenants: tenants,
          },
          successCb: () => {
            this.startSnack('success', this.$t('GuidelinesDetailTenant.updateGuidelineTenantSuccessMsg'))
          },
          failedCb: (err) => {
            this.startSnack('error', err)
          },
        }
        this.postUpdateGuidelineTenant(options)
      },
      deleteGuidelineTenant() {
        let options = {
          data: {
            GuidelineId: this.currentGuideline.Id,
            UnlinkTenantId: this.deleteTenant.Id,
          },
          successCb: () => {
            this.startSnack('success', this.$t('GuidelinesDetailTenant.deleteGuidelineTenantSuccessMsg'))
            this.comfirmDialog = false
          },
          failedCb: (err) => {
            this.startSnack('error', err)
          },
        }
        this.postUnlinkGuidelineTenant(options)
      },
    },
  }
</script>

<style>
  .center-checkbox {
    align-items: center;
    justify-content: center;
  }

  .center-checkbox>.v-input__control>.v-input__slot {
    margin-bottom: 0px;
  }

  .center-checkbox>.v-input__control>.v-input__slot>.v-input--selection-controls__input {
    margin-right: 0px;
  }
</style>
<style scoped>
  .backgroundColor {
    background-color: #fafafa;
  }

  .removePadding {
    padding: 0px;
  }

  .centerBtn {
    margin: 0 auto;
    display: block;
    width: 40%;
  }
</style>